import { httpService } from '@mfe-services/http';
import type {
    AutocompleteAPIResponse,
    AutocompleteParams,
    GeocodingAPIResponse,
    GeocodingParams,
    GeoCountry,
    LegacyType,
    PlaceAPIResponse,
} from '@mfe-types/geo';

const {
    NX_GEO_AUTOCOMPLETE_API_URL,
    NX_GEO_API_KEY,
    NX_GEO_PLACE_API_URL,
    NX_GEO_GEOCODING_API_URL,
} = process.env;

export const autocompleteAPI = async (
    params: AutocompleteParams,
): Promise<AutocompleteAPIResponse> => {
    const { data } = await httpService.get<AutocompleteAPIResponse>(
        `${NX_GEO_AUTOCOMPLETE_API_URL}/autocomplete`,
        {
            headers: {
                ['X-Api-key']: NX_GEO_API_KEY,
            },
            params,
        },
    );
    return data;
};

export const placeAPI = async (placeId: string): Promise<PlaceAPIResponse> => {
    const { data } = await httpService.get<PlaceAPIResponse>(
        `${NX_GEO_PLACE_API_URL}/places/${placeId}`,
        {
            headers: {
                ['X-Api-key']: NX_GEO_API_KEY,
            },
        },
    );
    return data;
};

// compatibility with legacy ids for mobile
export const legacyToAvivGeoDataAPI = async (
    platform: GeoCountry,
    id: string,
    type: LegacyType,
): Promise<PlaceAPIResponse> => {
    const { data } = await httpService.get<PlaceAPIResponse>(
        `${NX_GEO_PLACE_API_URL}/places/legacy/meilleursagents/${platform}/${id}/${type}`,
        {
            headers: {
                ['X-Api-key']: NX_GEO_API_KEY,
            },
        },
    );
    return data;
};

// does an address exist or not?
export const geoCodingAPI = async (params: GeocodingParams): Promise<GeocodingAPIResponse> => {
    const { data } = await httpService.get<GeocodingAPIResponse>(
        `${NX_GEO_GEOCODING_API_URL}/geocode/multiline`,
        {
            headers: {
                ['X-Api-key']: NX_GEO_API_KEY,
            },
            params,
        },
    );
    return data;
};
